document.addEventListener('DOMContentLoaded', function() {
  // Check if the device is mobile
  function isMobile() {
    return window.matchMedia("(max-width: 767px)").matches;
  }

  // Check if the device is tablet
  function isTablet() {
    return window.matchMedia("(min-width: 768px) and (max-width: 1024px)").matches;
  }

  // Clone and display the submenu
  function populateSubmenu(submenu) {
    var submenuClone = submenu.cloneNode(true);
    submenuClone.style.display = 'block';

    var submenuContainer = document.getElementById('submenu-container');
    submenuContainer.innerHTML = '';
    submenuContainer.appendChild(submenuClone);
  }

  // Populate the submenu for the current menu item
  function populateCurrentSubmenu() {
    var currentItem = document.querySelector('#menu-menu-1 .current-menu-item, #menu-prep-school .current-menu-ancestor, #menu-prep-school .current-menu-item, #menu-prep-school .current-menu-ancestor, #menu-prep-school .current-post-ancestor, #menu-senior-school .current-menu-item, #menu-senior-school .current-menu-ancestor, #menu-senior-school .current-post-ancestor');
    if (currentItem) {
      var closestParentWithSubmenu = currentItem.closest('.menu-item-has-children');
      if (closestParentWithSubmenu) {
        var submenu = closestParentWithSubmenu.querySelector('.sub-menu');
        if (submenu) {
          populateSubmenu(submenu);
        }
      }
    }
  }

  // Populate submenu for the current page by default
  populateCurrentSubmenu();

  // Remove 'open' class from all menu items
  function clearOpenClasses() {
    document.querySelectorAll('#menu-menu-1 > li.menu-item-has-children > a, #menu-prep-school > li.menu-item-has-children > a, #menu-senior-school > li.menu-item-has-children > a').forEach(function(item) {
      item.classList.remove('open');
    });
  }

  // Hide any open submenus
  function hideSubmenus() {
    document.querySelectorAll('#submenu-container .sub-menu').forEach(function(submenu) {
      submenu.style.display = 'none';
    });
  }


  // Add event listeners for menu items
  document.querySelectorAll('#menu-menu-1  > li > a,#menu-prep-school > li > a, #menu-senior-school > li > a').forEach(function(menuItem) {
    // Click event for mobile and tablet
    menuItem.addEventListener('click', function(e) {
      if (isMobile() || isTablet()) {
        // e.preventDefault();
        var submenu = this.nextElementSibling;
        if (submenu && submenu.tagName === 'UL') {
          if (isTablet()) {
            populateSubmenu(submenu);
          } else {
            submenu.style.display = submenu.style.display === 'block' ? 'none' : 'block';
          }
          this.classList.toggle('open');
        }
      }
    });

    // Mouseover event for desktop
    if (!isMobile() && !isTablet()) {
      menuItem.addEventListener('mouseover', function(e) {
        clearOpenClasses();
        if (this.nextElementSibling && this.nextElementSibling.tagName === 'UL') {
          this.classList.add('open');
          var submenu = this.nextElementSibling;
          if (submenu && submenu.tagName === 'UL') {
            populateSubmenu(submenu);
          }
        } else {
          hideSubmenus();
        }
        e.preventDefault(); // Prevent default to stop any link navigation
        e.stopPropagation(); // Prevent any parent handlers from being executed
      });
    }
  });

  // Prevent deeper nested submenu items from affecting the submenu-container
  document.querySelectorAll('.menu-item-has-children .menu-item-has-children > a').forEach(function(item) {
    item.addEventListener('mouseover', function(e) {
      e.stopPropagation(); // This prevents the event from bubbling up to the top-level menu items
    });
  });
});

document.addEventListener('DOMContentLoaded', function() {
  // Create a button element for toggling submenus
  function createButton() {
    const button = document.createElement('button');
    button.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M12.53 16.28a.75.75 0 01-1.06 0l-7.5-7.5a.75.75 0 011.06-1.06L12 14.69l6.97-6.97a.75.75 0 111.06 1.06l-7.5 7.5z" clip-rule="evenodd" /></svg>';
    button.classList.add('menu-item-button');
    button.setAttribute('aria-label', 'Toggle Submenu');
    return button;
  }

  // Add toggle buttons to menu items
  function addButtonsToMenuItems() {
    const menuItems = document.querySelectorAll('#submenu-container .menu-item-has-children');
    menuItems.forEach(menuItem => {
      if (!menuItem.querySelector('.menu-item-button')) {
        const button = createButton();
        menuItem.appendChild(button);
      }
      const subMenu = menuItem.querySelector('.sub-menu');
      if (menuItem.classList.contains('open')) {
        subMenu.style.height = subMenu.scrollHeight + 'px'; // Ensure it's set correctly if open
      } else {
        subMenu.style.height = '0px'; // Ensure it starts closed
      }
    });
  }

  addButtonsToMenuItems();

  const parentContainer = document.getElementById('submenu-container');
  parentContainer.addEventListener('click', function(event) {
    if (event.target.matches('.menu-item-button')) {
      const parentListItem = event.target.closest('.menu-item-has-children');
      const subMenu = parentListItem.querySelector('.sub-menu');
      const menuItems = parentListItem.querySelectorAll('.menu-item');
      if (parentListItem.classList.contains('open')) {
        // Closing the submenu
        subMenu.style.height = '0px';
        menuItems.forEach(item => {
          item.classList.remove('open');
          item.classList.add('close');
        });
      } else {
        // Opening the submenu
        subMenu.style.height = '0px'; // Reset height to reflow
        requestAnimationFrame(() => {
          subMenu.style.height = subMenu.scrollHeight + 'px';
        });
        menuItems.forEach(item => {
          item.classList.remove('close');
          item.classList.add('open');
        });
      }
      parentListItem.classList.toggle('open');
    }
  });

  // Mutation observer for dynamically added submenus
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.type === 'childList' && mutation.addedNodes.length) {
        addButtonsToMenuItems();
      }
    });
  });

  observer.observe(document.getElementById('submenu-container'), {
    childList: true,
    subtree: true
  });
});
